import { render } from "./check.vue?vue&type=template&id=01e1da21&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"

import "./check.vue?vue&type=style&index=0&id=01e1da21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e1da21"]])

export default __exports__